module.exports = __webpack_public_path__ + "img/morocco-logo-icon.8fd13911.png";